export default __webpack_public_path__ + "static/card-back-2-9ad733efcfe499942825a8f220db900f.png";